/*   */

if (window.fcTestHasRun) throw "Script tried to load twice";
window.fcTestHasRun = true;

// +------------------+
// | Helper functions |
// +------------------+
/**
 * Turn a normal function into an async function
 * @param {Function} func Function to make async
 * @param {Function} validator Determines if func output is ready to return
 * @param {Int} timeout How long we should wait in miliseconds
 * @returns {Promise} the output of func that has passed the validator
 */
async function asyncify(
  func,
  validator = (x) => Boolean(x),
  defaultReturn = null
) {
  let timeout = 10000;
  return new Promise((resolve, reject) => {
    const result = func();
    if (validator(result)) return resolve(result);
    const interval = setInterval(function () {
      const result = func();
      if (validator(result)) {
        resolve(result);
        clearInterval(interval);
      }
      if (timeout <= 0) resolve(defaultReturn);
      timeout -= 100;
    }, 100);
  });
}
async function asyncSelectAll(selector, root = document) {
  return asyncify(
    () => [...root.querySelectorAll(selector)],
    (result) => result.length > 0,
    []
  );
}
async function asyncSelect(selector, root = document) {
  return asyncify(
    () => root.querySelector(selector),
    (x) => Boolean(x)
  );
}
// +---------------+
// | Button Events |
// +---------------+
// Common Button Events
function fcButtonEvents({ target }) {
  // If element is in a button, run the event on the button element
  const buttonSelector = ["BUTTON", "A", "[data-fc-button]"];
  if (!buttonSelector.includes(target.nodeName)) {
    target = target.closest(buttonSelector.join());
    if (!target) return;
  }
  // In case we want to add styling when the button has been clicked
  target.classList.add("fc-btn--clicked");
  if (target.dataset.hide) {
    [...document.querySelectorAll(target.dataset.hide)].forEach((elem) =>
      elem.classList.add("fc-hide")
    );
  }
  if (target.dataset.show) {
    [...document.querySelectorAll(target.dataset.show)].forEach((elem) => {
      elem.classList.remove("fc-hide");
    });
  }
  if (target.dataset.openLightbox) {
    window.hasOpenedLightbox = true;
    // Open the lightbox
    const lightbox = document.querySelector(target.dataset.openLightbox);
    if (!lightbox) {
      console.error(target.dataset.openLightbox + " doesen't exist");
    } else if (!lightbox.classList.contains("fc-lightbox")) {
      actionFunctions
        .makeLightbox({
          lightbox,
        })
        .then((lightbox) => lightbox?.dispatchEvent(new Event("open")));
    } else {
      lightbox?.dispatchEvent(new Event("open"));
    }
    const hideOtherCTAs = () => {
      console.log("hiding other full-story ctas");
      const fullStoryIds = ["#full-story", "#sitewide-full-story"];
      if (!fullStoryIds.includes(target.dataset.openLightbox)) return;
      const buttonSelector = `[data-open-lightbox="${target.dataset.openLightbox}"]`;
      // Hide all other buttons that open the same lightbox
      [...document.querySelectorAll(buttonSelector)].forEach((button) => {
        if (button === target || !button.matches(buttonSelector)) return;
        const container = button.parentElement.closest(".cta-container");
        (container ? container : button).classList.add("fc-hide");
      });
      // Save which button was clicked in local storage so we can hide it on page refresh
      let fcClickedCTAObj = JSON.parse(
        localStorage.getItem("fc-clicked-cta-" + testMetadata.id)
      );
      if (!fcClickedCTAObj) fcClickedCTAObj = {};
      fcClickedCTAObj[target.dataset.openLightbox] = {
        path: window.location.pathname,
        buttonIndex: [...document.querySelectorAll(buttonSelector)].findIndex(
          (button) => button === target
        ),
      };
      localStorage.setItem(
        "fc-clicked-cta-" + testMetadata.id,
        JSON.stringify(fcClickedCTAObj)
      );
    };
    // If the lightbox is still open after 5 seconds, hide the other ctas
    setTimeout(() => {
      const htmlElem = document.documentElement;
      const lightboxIsOpem = htmlElem.classList.contains("fc-lightbox-open");
      if (lightboxIsOpem) hideOtherCTAs();
    }, 5000);
  }
  if (target.dataset.closeLightbox) {
    const lightbox = document.querySelector(target.dataset.closeLightbox);
    lightbox.dispatchEvent(new Event("close"));
  }
  if (target.dataset.replaceParentWith) {
    const parentElement = target.dataset.parent
      ? target.closest(target.dataset.parent)
      : target.parentElement;
    parentElement.innerHTML = target.dataset.replaceParentWith;
  }
  if (target.dataset.scrollTo) {
    const elem = document.querySelector(target.dataset.scrollTo);
    let block = "center";
    if (elem.offsetHeight > window.innerHeight + 100) {
      block = "start";
    }
    elem.scrollIntoView({ block, behavior: "smooth" });
  }
  if (target.dataset.setKey && target.dataset.toValue) {
    localStorage.setItem(target.dataset.setKey, target.dataset.toValue);
    asyncSelectAll(`[data-variable-name="${target.dataset.setKey}"]`).then(
      (variableElems) => {
        variableElems.forEach((variableElem) => {
          variableElem.innerHTML = target.dataset.toValue;
        });
      }
    );
  }
  if (target.dataset.goal && typeof ga !== "undefined") {
    const pageURL = window.location.hostname + window.location.pathname;
    ga("send", "event", {
      eventCategory: "Page interaction",
      eventAction: "click",
      eventLabel: target.dataset.goal + "(" + pageURL + ")",
    });
  }
  return false;
}
asyncSelect("body").then((body) =>
  body.addEventListener("click", fcButtonEvents)
);
// +--------------------------+
// | Custom code for the test |
// +--------------------------+
const testMetadata = {
  "id": "r1c1a1"
};
const actions = [
	{
	  "type": "assign",
	  "arg1": "isMobile",
	  "arg3": "window.innerWidth < 750",
	  "contents": ""
	},
	{
	  "type": "assign",
	  "arg1": "isDesktop",
	  "arg3": "window.innerWidth > 750",
	  "contents": ""
	},
	{
	  "type": "append",
	  "arg1": ".product-single__price",
	  "inline": "true",
		"contents": /*html*/`
			<button type="button" class="fc-btn fc-btn--inline" data-open-lightbox="#full-story" style="display: none">Quality Matters</button>		
		`
	},
	{
	  "type": "addLightboxPreview",
	  "arg1": "beforeBegin",
	  "arg2": ".product-single__accordion",
		"contents": /*html*/`
			<p style="text-align: center;"><button type="button" class="fc-btn fc-show" data-open-lightbox="#full-story">Continue Reading →</button></p>
			<p>
			  <style>
			    .inline-lfsp {
			      border: solid 1px;
			    }
			
			    .lightbox-preview__button {
			      margin-bottom: -80px;
			    }
			  </style>
			</p>		
		`
	},
	{
	  "type": "after",
	  "arg1": ".product-single__accordion hr",
		"contents": /*html*/`
<div class="cta-container fc-show" style="display: none">
			<p><span style="font-size: 1.66666875em">✋ </span><a class="fc-link" style="cursor: pointer !important;" data-open-lightbox="#full-story">Are you new here?</a></p>
			<hr>
			<p>
			  <style>
			    .fc-link {
			      vertical-align: top;
			    }
			  </style>
			</p>		</div>
		`
	},
	{
	  "type": "append",
	  "arg1": ".pdp-sws-section__products",
		"contents": /*html*/`
			<div class="fc-banner cta-container" style="background: #ef8e74; color: #000000; display: none">
			  <div style="--fc-accent: #000000">
			    <p style="text-align: center;"><a class="fc-link" style="cursor: pointer !important;" data-open-lightbox="#full-story">NATURE’S MIRACLES</a></p>
			  </div>
			</div>
			  <style>
			    .fc-banner {
			      padding: 0.4em;
			      margin-top: -1em;
			    }
			
			    .fc-banner p {
			      margin: 0;
			    }
			  </style>
		`
	},
	{
	  "type": "makeLightbox",
	  "metadata": {
	    "customGoals": {}
	  },
	  "id": "full-story",
		"contents": /*html*/`
			<h1>Made By Moms In Medicine™</h1>
			<p>It all begins with a baby’s skin.</p>
			<p>We didn’t have a time machine to fix our childhood skin routines, so–with the help of our 3 Harvard and Stanford doctors–we did the next best thing:</p>
			<p><b>FIX IT FOR OUR KIDS (AND YOURS).</b></p>
			<p>
			</p>
			<div class="split__media" style="height: ;">
			  <div class="split__video hide" id="herovideomodalmobiletemplate--15091982893116__16310949233d212888">
			    <header class="video__header">
			      <button class="video__close" aria-label="Close modal" onclick="document.getElementById('herovideomodalmobilevideotemplate--15091982893116__16310949233d212888').pause();document.getElementById('herovideomodalmobiletemplate--15091982893116__16310949233d212888').classList.add('hide');document.exitFullscreen()"></button>
			    </header>
			    <video id="herovideomodalmobilevideotemplate--15091982893116__16310949233d212888" src="https://cdn.shopify.com/s/files/1/0009/7137/4652/files/30_Sec_Anthem_Mobile_Compressed.mp4?v=1631571154" tabindex="-1" onended="document.getElementById('herovideomodalmobiletemplate--15091982893116__16310949233d212888').classList.add('hide');document.exitFullscreen()" controls="" nofullscreen="" playsinline="" controlslist="nodownload noremoteplayback noplay"></video>
			  </div>
        <button class="split__video--play-button" onclick="document.getElementById('herovideomodalmobiletemplate--15091982893116__16310949233d212888').classList.remove('hide'); document.getElementById('herovideomodalmobilevideotemplate--15091982893116__16310949233d212888').play();">
			    <img id="image-21251158769724" width="750" height="750" class="responsive-image " src="//www.ever-eden.com/cdn/shop/t/1117/assets/lightbox-video-poster.png?v=42733381000063247521791994647"  alt="Play video">
        </button>
			</div>
			<style>
			  .split__video:not(.hide)+.split__video--play-button {
			    display: none;
			  }
        .split__video--play-button {
          background: transparent;
          border: 0;
          padding: 0;
        }
			</style>
			<div data-if="isDesktop">
			  <p>
			  </p>
			  <div class="glider-contain">
			    <div class="glider" data-slides-to-show="3" data-auto-slide="false">
			      <div class="carousel-slide swiper-slide swiper-slide-active" role="group" aria-label="profile">
			        <div class="doctor-profile-grid-item">
			          <div class="doctor-profile-grid-item__background">
			            <div class="doctor-profile-grid-item__image">
			              <img id="image-21232239214652" width="414" height="414" loading="lazy" class="responsive-image" src="https://www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrJoyce_2X_dc6d3dda-e48e-447c-b4b2-b2b654d29ec5_414x.png?v=1631380704" srcset="
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrJoyce_2X_dc6d3dda-e48e-447c-b4b2-b2b654d29ec5_180x.png?v=1631380704  180w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrJoyce_2X_dc6d3dda-e48e-447c-b4b2-b2b654d29ec5_360x.png?v=1631380704  360w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrJoyce_2X_dc6d3dda-e48e-447c-b4b2-b2b654d29ec5_414x.png?v=1631380704 3024w
			              " tabindex="-1" alt="Headshot of Dr. Joyce Teng">
			            </div>
			            <h3 class="doctor-profile-grid-item__name">DR. JOYCE TENG, MD, PhD</h3>
			            <div class="doctor-profile-grid-item__bio">
			              <p>
			                Chief Scientific Officer, Evereden <br>Head of Pediatric
			                Dermatology,<br><strong>Stanford Medical School</strong>.
			              </p>
			            </div>
			            <div class="doctor-profile-grid-item__autograph">
			              <img alt="signature of Dr. Joyce Teng" src="https://www.ever-eden.com/cdn/shop/files/Dr.JoyceTeng_2x_e0298284-dd7d-46f2-9055-17c9690e01e6_300x300@2x.jpg?v=1614767754">
			            </div>
			
			            <div class="doctor-profile-grid-item__bottom-content">
			              <div class="doctor-profile-grid-item__accomplishments">
			                <h4 class="accomplishments__title">Number of Children</h4>
			                <p class="accomplishments__answer">3</p>
			                <h4 class="accomplishments__title">
			                  Research articles on pediatric dermatology written:
			                </h4>
			                <p class="accomplishments__answer">100 and counting</p>
			                <h4 class="accomplishments__title">Specialty</h4>
			                <p class="accomplishments__answer">
			                  Pediatric dermatologic surgery, vascular anomalies, inflammatory
			                  skin diseases
			                </p>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			
			      <div class="carousel-slide swiper-slide swiper-slide-next" style="width: 375px;" role="group" aria-label="profile">
			        <div class="doctor-profile-grid-item">
			          <div class="doctor-profile-grid-item__background">
			            <div class="doctor-profile-grid-item__image">
			              <img id="image-21242148388924" width="414" height="414" loading="lazy" class="responsive-image" src="https://www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrSarina_2X_1_414x.png?v=1631548295" srcset="
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrSarina_2X_1_180x.png?v=1631548295  180w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrSarina_2X_1_360x.png?v=1631548295  360w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrSarina_2X_1_414x.png?v=1631548295 3024w
			              " tabindex="-1" alt="Headshot of Dr. Sarina Elmariah">
			            </div>
			            <h3 class="doctor-profile-grid-item__name">
			              DR. SARINA ELMARIAH, MD, PhD
			            </h3>
			            <div class="doctor-profile-grid-item__bio">
			              <p>
			                Evereden&nbsp;Scientific Officer,&nbsp;Professor of
			                Dermatology,&nbsp;<strong>Harvard Medical School.&nbsp;</strong>
			              </p>
			            </div>
			            <div class="doctor-profile-grid-item__autograph">
			              <img alt="signature of Dr. Sarina Elmariah" src="https://www.ever-eden.com/cdn/shop/files/Dr.Sarina_2x_ca435fd2-ca73-45dd-83a3-9900f9854e50_300x300@2x.jpg?v=1614767754">
			            </div>
			
			            <div class="doctor-profile-grid-item__bottom-content">
			              <div class="doctor-profile-grid-item__accomplishments">
			                <h4 class="accomplishments__title">Number of Children</h4>
			                <p class="accomplishments__answer">2</p>
			                <h4 class="accomplishments__title">Number of Degrees</h4>
			                <p class="accomplishments__answer">
			                  3. In addition to her BA and MD, she also earned a PhD in
			                  developmental neuroscience
			                </p>
			                <h4 class="accomplishments__title">Specialty</h4>
			                <p class="accomplishments__answer">
			                  Chronic itching disorders, eczema, psoriasis, allergic skin
			                  reactions, cutaneous lymphomas, and wound healing
			                </p>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			
			      <div class="carousel-slide swiper-slide" style="width: 375px;" role="group" aria-label="profile">
			        <div class="doctor-profile-grid-item">
			          <div class="doctor-profile-grid-item__background">
			            <div class="doctor-profile-grid-item__image">
			              <img id="image-21242149109820" width="414" height="414" loading="lazy" class="responsive-image" src="https://www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrRebecca_2X_1_414x.png?v=1631548310" srcset="
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrRebecca_2X_1_180x.png?v=1631548310  180w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrRebecca_2X_1_360x.png?v=1631548310  360w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrRebecca_2X_1_414x.png?v=1631548310 3024w
			              " tabindex="-1" alt="Headshot of Dr. Rebecca Hartman">
			            </div>
			            <h3 class="doctor-profile-grid-item__name">
			              Dr. Rebecca Hartman, MD, MPH
			            </h3>
			            <div class="doctor-profile-grid-item__bio">
			              <p>
			                Evereden&nbsp;Scientific Officer,&nbsp;Assistant Professor of
			                Dermatology, <strong>Harvard Medical School.</strong>
			              </p>
			            </div>
			            <div class="doctor-profile-grid-item__autograph">
			              <img alt="signature of Dr. Rebecca Hartman" src="https://www.ever-eden.com/cdn/shop/files/signature_0aa0839d-4302-4b59-808b-9edb55a1127e.png?v=1631721623">
			            </div>
			
			            <div class="doctor-profile-grid-item__bottom-content">
			              <div class="doctor-profile-grid-item__accomplishments">
			                <h4 class="accomplishments__title">Number of Children</h4>
			                <p class="accomplishments__answer">2</p>
			                <h4 class="accomplishments__title">Extracurricular</h4>
			                <p class="accomplishments__answer">
			                  When she’s not seeing patients, Dr. Rebecca can be found in her
			                  research lab, focusing on her study of melanoma
			                </p>
			                <h4 class="accomplishments__title">Specialty</h4>
			                <p class="accomplishments__answer">
			                  Medical dermatology, cutaneous oncology, melanoma
			                </p>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			
			    <button aria-label="Previous" type="button" class="glider-prev"></button>
			    <button aria-label="Next" type="button" class="glider-next"></button>
			  </div>
			
			</div>
			<div data-if="isMobile">
			  <p>
			  </p>
			  <div class="glider-contain">
			    <div class="glider" data-slides-to-show="1" data-auto-slide="false">
			      <div class="carousel-slide swiper-slide swiper-slide-active" role="group" aria-label="profile">
			        <div class="doctor-profile-grid-item">
			          <div class="doctor-profile-grid-item__background">
			            <div class="doctor-profile-grid-item__image">
			              <img id="image-21232239214652" width="414" height="414" loading="lazy" class="responsive-image" src="https://www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrJoyce_2X_dc6d3dda-e48e-447c-b4b2-b2b654d29ec5_414x.png?v=1631380704" srcset="
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrJoyce_2X_dc6d3dda-e48e-447c-b4b2-b2b654d29ec5_180x.png?v=1631380704  180w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrJoyce_2X_dc6d3dda-e48e-447c-b4b2-b2b654d29ec5_360x.png?v=1631380704  360w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrJoyce_2X_dc6d3dda-e48e-447c-b4b2-b2b654d29ec5_414x.png?v=1631380704 3024w
			              " tabindex="-1" alt="Headshot of Dr. Joyce Teng">
			            </div>
			            <h3 class="doctor-profile-grid-item__name">DR. JOYCE TENG, MD, PhD</h3>
			            <div class="doctor-profile-grid-item__bio">
			              <p>
			                Chief Scientific Officer, Evereden <br>Head of Pediatric
			                Dermatology,<br><strong>Stanford Medical School</strong>.
			              </p>
			            </div>
			            <div class="doctor-profile-grid-item__autograph">
			              <img alt="signature of Dr. Joyce Teng" src="https://www.ever-eden.com/cdn/shop/files/Dr.JoyceTeng_2x_e0298284-dd7d-46f2-9055-17c9690e01e6_300x300@2x.jpg?v=1614767754">
			            </div>
			
			            <div class="doctor-profile-grid-item__bottom-content">
			              <div class="doctor-profile-grid-item__accomplishments">
			                <h4 class="accomplishments__title">Number of Children</h4>
			                <p class="accomplishments__answer">3</p>
			                <h4 class="accomplishments__title">
			                  Research articles on pediatric dermatology written:
			                </h4>
			                <p class="accomplishments__answer">100 and counting</p>
			                <h4 class="accomplishments__title">Specialty</h4>
			                <p class="accomplishments__answer">
			                  Pediatric dermatologic surgery, vascular anomalies, inflammatory
			                  skin diseases
			                </p>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			
			      <div class="carousel-slide swiper-slide swiper-slide-next" style="width: 375px;" role="group" aria-label="profile">
			        <div class="doctor-profile-grid-item">
			          <div class="doctor-profile-grid-item__background">
			            <div class="doctor-profile-grid-item__image">
			              <img id="image-21242148388924" width="414" height="414" loading="lazy" class="responsive-image" src="https://www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrSarina_2X_1_414x.png?v=1631548295" srcset="
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrSarina_2X_1_180x.png?v=1631548295  180w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrSarina_2X_1_360x.png?v=1631548295  360w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrSarina_2X_1_414x.png?v=1631548295 3024w
			              " tabindex="-1" alt="Headshot of Dr. Sarina Elmariah">
			            </div>
			            <h3 class="doctor-profile-grid-item__name">
			              DR. SARINA ELMARIAH, MD, PhD
			            </h3>
			            <div class="doctor-profile-grid-item__bio">
			              <p>
			                Evereden&nbsp;Scientific Officer,&nbsp;Professor of
			                Dermatology,&nbsp;<strong>Harvard Medical School.&nbsp;</strong>
			              </p>
			            </div>
			            <div class="doctor-profile-grid-item__autograph">
			              <img alt="signature of Dr. Sarina Elmariah" src="https://www.ever-eden.com/cdn/shop/files/Dr.Sarina_2x_ca435fd2-ca73-45dd-83a3-9900f9854e50_300x300@2x.jpg?v=1614767754">
			            </div>
			
			            <div class="doctor-profile-grid-item__bottom-content">
			              <div class="doctor-profile-grid-item__accomplishments">
			                <h4 class="accomplishments__title">Number of Children</h4>
			                <p class="accomplishments__answer">2</p>
			                <h4 class="accomplishments__title">Number of Degrees</h4>
			                <p class="accomplishments__answer">
			                  3. In addition to her BA and MD, she also earned a PhD in
			                  developmental neuroscience
			                </p>
			                <h4 class="accomplishments__title">Specialty</h4>
			                <p class="accomplishments__answer">
			                  Chronic itching disorders, eczema, psoriasis, allergic skin
			                  reactions, cutaneous lymphomas, and wound healing
			                </p>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			
			      <div class="carousel-slide swiper-slide" style="width: 375px;" role="group" aria-label="profile">
			        <div class="doctor-profile-grid-item">
			          <div class="doctor-profile-grid-item__background">
			            <div class="doctor-profile-grid-item__image">
			              <img id="image-21242149109820" width="414" height="414" loading="lazy" class="responsive-image" src="https://www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrRebecca_2X_1_414x.png?v=1631548310" srcset="
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrRebecca_2X_1_180x.png?v=1631548310  180w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrRebecca_2X_1_360x.png?v=1631548310  360w,
			                //www.ever-eden.com/cdn/shop/files/2_MomsinMed_Portrait_DrRebecca_2X_1_414x.png?v=1631548310 3024w
			              " tabindex="-1" alt="Headshot of Dr. Rebecca Hartman">
			            </div>
			            <h3 class="doctor-profile-grid-item__name">
			              Dr. Rebecca Hartman, MD, MPH
			            </h3>
			            <div class="doctor-profile-grid-item__bio">
			              <p>
			                Evereden&nbsp;Scientific Officer,&nbsp;Assistant Professor of
			                Dermatology, <strong>Harvard Medical School.</strong>
			              </p>
			            </div>
			            <div class="doctor-profile-grid-item__autograph">
			              <img alt="signature of Dr. Rebecca Hartman" src="https://www.ever-eden.com/cdn/shop/files/signature_0aa0839d-4302-4b59-808b-9edb55a1127e.png?v=1631721623">
			            </div>
			
			            <div class="doctor-profile-grid-item__bottom-content">
			              <div class="doctor-profile-grid-item__accomplishments">
			                <h4 class="accomplishments__title">Number of Children</h4>
			                <p class="accomplishments__answer">2</p>
			                <h4 class="accomplishments__title">Extracurricular</h4>
			                <p class="accomplishments__answer">
			                  When she’s not seeing patients, Dr. Rebecca can be found in her
			                  research lab, focusing on her study of melanoma
			                </p>
			                <h4 class="accomplishments__title">Specialty</h4>
			                <p class="accomplishments__answer">
			                  Medical dermatology, cutaneous oncology, melanoma
			                </p>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			
			    <button aria-label="Previous" type="button" class="glider-prev"></button>
			    <button aria-label="Next" type="button" class="glider-next"></button>
			  </div>
			
			
			  <div class="glider-contain" id="undefined">
			    <div class="glider" data-slides-to-show="1" data-auto-slide="-1">
			
			    </div>
			
			    <button aria-label="Previous" type="button" class="glider-prev"></button>
			    <button aria-label="Next" type="button" class="glider-next"></button>
			
			  </div>
			</div>
			<p>
			  <style>
			    .glider-contain+.glider-contain {
			      display: none;
			    }
			
			    .fc-lightbox .glider-contain {
			      margin: 0;
			      width: 100%;
			    }
			
			    .glider-prev,
			    .glider-next {
			      transform: none !important;
			    }
			
			    @media (min-width: 750px) {
			
			      .glider-next,
			      .glider-prev {
			        display: none !important;
			      }
			    }
			  </style>
			</p>
			<p><span class="fc-checkpoint" data-custom-goal="Viewed LFSP Section 1"></span></p>
			<h1>Nature’s Miracles</h1>
			<p>It’s clear nature has all the best ideas.</p>
			<p>We simply seek out secrets she hides in her many miracles.</p>
			<p>It may take us a while, but we’re determined doctor moms. Our Stretch Mark Cream took a year to make. Our Baby Lotion took two.</p>
			<p><span class="fc-checkpoint" data-custom-goal="Viewed LFSP Section 2"></span></p>
			<h1>Not a Perfect World</h1>
			<p>Think back to purchases you’ve made over the last 5 years. Not just purchases for the family but <b>any purchase</b>. Now, think back to how many truly lived up to your expectations. Brands simply have to do a better job.</p>
			<p>We may be unable to control the world, but nothing will stop us from adding a protective bubble for our kids.</p>
			<p>Most parents are so busy they don’t even have time to wonder about how their kid’s skincare needs could be different. So they never discover Evereden, which is a shame.</p>
			<p>We’ve known for a long time that children have specialized needs. It’s why pediatrics is a specialist branch of medicine.</p>
			<div style="text-align: center;"><img title="what we wish we had when we were young" alt="what we wish we had when we were young" src="//www.ever-eden.com/cdn/shop/t/1117/assets/lightbox_mim.jpg?v=184295323786578895581791994647" width="1227"></div>
			<p><span class="fc-checkpoint" data-custom-goal="Viewed LFSP Section 3"></span></p>
			<h1>On Your Own Terms</h1>
			<p>There’s far too much pressure to buy now, act now. Don’t feel rushed. We aren’t going anywhere. And when you’re ready, we look forward to showing you what we, at Evereden, stand for.</p>
			<p style="text-align: center;"><button type="button" class="fc-btn fc-btn--close-lightbox" data-close-lightbox="#full-story">Continue →</button></p>
			<p><span class="fc-checkpoint" data-custom-goal="Viewed LFSP Section 4"></span></p>		
		`
	},
	{
	  "type": "momsInMedicinSliderEvent",
	  "contents": ""
	},
	{
	  "type": "galleryEvents",
	  "contents": ""
	},
	{
	  "type": "loadCheckpointEvents",
	  "id": "loadCheckpointEvents",
	  "contents": ""
	},
	{
	  "type": "trackTestInfo",
	  "contents": ""
	}	
];
const actionFunctions = {
assign: ({ arg1: name, arg3: expression, dynamic = false }) => {
  console.log({ name, expression, dynamic });
  if (expression[0].match(/['"]/)) {
    expression = expression.slice(1, -1);
  }
  // Try for 10 seconds
  let attempts = 0;
  const assignVariable = () => {
    try {
      // Utility functions for assign
      const urlContains = (urlPart) =>
        window.location.pathname.includes(urlPart);
      // Get the value
      const value = eval(expression);
      if (typeof value === "undefined") throw "value is undefined";
      if (String(value) === "NaN") throw "value is NaN";
      window.localStorage.setItem(name, value);
      const varElems = document.querySelectorAll(
        `[data-variable-name="${name}"]`
      );
      [...varElems].forEach((span) => (span.innerHTML = value));
      if (dynamic) setTimeout(assignVariable, 1000);
    } catch (error) {
      if (attempts <= 20 || dynamic) {
        attempts++;
        setTimeout(assignVariable, 500);
      } else {
        console.warn("Assign", name, "to", expression, "failed");
      }
    }
  };
  assignVariable();
},
append: async ({ arg1: selector, contents }) => {
  const elems = await asyncSelect(selector);
  elems.insertAdjacentHTML("beforeEnd", contents);
},
addLightboxPreview: async function addLightboxPreview({
  arg1: position,
  arg2: selector,
  contents,
  preview_length = "3",
  for_lightbox = "#full-story",
  backgroundRGB = "255,255,255",
  stripImages = false,
  style = "",
}) {
  const elem = await asyncSelect(selector);
  if (!elem) return;
  elem.insertAdjacentHTML(
    position,
    /*html*/ `
      <div class="inline-lfsp lightbox-preview cta-container fc-show" style="${style}">
        <div class="full-story">
          <div class="full-story__row">
            <div class="full-story__content">
              <h4>Made by Moms in Medicine™</h4>
              <p>It all begins with a baby's skin.</p>
              <p>We didn’t have a time machine to fix our childhood skin routines, so–with the help of our 3 Harvard and Stanford doctors–we did the next best thing.</p>
              <div class="full-story__action"><a id="full-story-cta" data-open-lightbox="#full-story" class="fc-show" href="#full-story">Continue Reading</a></div></div></div></div>
      </div>
    `
  );
  document.querySelector('.lightbox-preview .full-story').addEventListener('click', function(e){
    this.querySelector('#full-story-cta').click();
  })
  const lightbox = await asyncSelect(for_lightbox);
  const firstImgIndex =
    [...lightbox.children].findIndex((x) => x.querySelector("img")) - 1;
  preview_length = parseInt(preview_length);
  if (firstImgIndex > 0 && !stripImages) {
    preview_length = Math.min(preview_length, firstImgIndex);
  }
  console.log({
    preview_length,
    selected: [...lightbox.children].slice(1, preview_length + 2),
  });
  const previewContent = [...lightbox.children]
    .slice(1, preview_length + 1)
    .filter((x) => !stripImages || !x.querySelector("img"))
    .map((x) => x.outerHTML)
    .join("");
  console.log({ previewContent });
  const root = document.createElement("div");
  root.innerHTML = previewContent;
  root.querySelectorAll(".fc-checkpoint").forEach((x) => x.remove());
  // elem.parentElement.querySelector(".lightbox-preview__content").innerHTML = root.innerHTML;
},
after: async ({ arg1: selector, contents }) => {
  const elems = await asyncSelect(selector);
  if(elems) {
    elems.insertAdjacentHTML("afterEnd", contents);
  }
},
makeLightbox: ({ id, contents, metadata, autoOpen = false }) => {
  const trackOpen = () => {
    console.log("Opened " + id, { metadata });
    // Hotjar tracking
    if (typeof hj !== "undefined") {
      hj("event", testMetadata.id + "-open-lightbox-" + id);
      hj("event", "open-lightbox");
    }
    // CrazyEgg Tracking
    if (typeof CE2 !== "undefined") {
      CE2.addTag(testMetadata.id + "-open-lightbox-" + id);
      CE2.addTag("open-lightbox");
    }
    // Microsoft Clarity Tracking
    if (window.clarity) {
      window.clarity("set", testMetadata.id + "-open-lightbox-" + id, true);
      window.clarity("set", "open-lightbox", true);
    }
    // Universal Google Analytics (Remove after June 2023)
    if (typeof ga !== "undefined") {
      ga("send", "event", {
        eventCategory: "Page interaction",
        eventAction: "click",
        eventLabel: testMetadata.id + "-open-lightbox-" + id,
      });
    }
    // VWO tracking
    window._vis_opt_queue = window._vis_opt_queue || [];
    window._vis_opt_queue.push(function () {
      _vis_opt_goal_conversion(metadata.customGoals["Opened"]);
    });
    // Queue the conversion goal for if/when the user converts
    const conversionGoals =
      localStorage.getItem("fc_conversion_goals")?.split(",") || [];
    localStorage.setItem(
      "fc_conversion_goals",
      [...conversionGoals, metadata.customGoals["Converted"]].join(",")
    );
  };
  const trackBounce = () => {
    console.log("Bounced " + id);
    // VWO tracking
    window._vis_opt_queue = window._vis_opt_queue || [];
    window._vis_opt_queue.push(function () {
      _vis_opt_goal_conversion(metadata.customGoals["Bounced"]);
    });
  };
  async function lightboxEvents(lightbox) {
    const container = lightbox.parentElement;
    // This script always loads in the header, so wait till we can access body
    const body = await asyncSelect("body");
    const openLightbox = () => {
      trackOpen();
      // For conditionally doing things based on if the lightbox has been
      // opened on other pages
      localStorage.setItem("opened-" + id, true);
      // So back button closes lightbox
      history.pushState({}, "", "#" + id);
      // Move lightbox to the body elem so that it can always show above
      // other high z-index items
      if (container.parentElement !== body) {
        document.body.appendChild(container);
      }
      // Open the lightbox
      container.classList.remove("fc-hide");
      // Always scroll to the top of open lightboxes
      container.scrollTop = 0;
      var scrollBarWidth = window.innerWidth - body.offsetWidth;
      document.body.style.marginRight = scrollBarWidth + "px";
      document.documentElement.classList.add("fc-lightbox-open");
      // Listen for bounces
      const openTime = new Date() * 1;
      const listenForBounce = () => {
        const closeTime = new Date() * 1;
        if (closeTime - openTime < 5000) {
          trackBounce();
        }
        lightbox.removeEventListener("close", listenForBounce);
      };
      lightbox.addEventListener("close", listenForBounce);
    };
    const closeLightbox = () => {
      history.pushState({}, "", window.location.pathname);
      document.body.style.marginRight = "0px";
      lightbox.classList.add("fc-fade-out");
      setTimeout(() => {
        container.classList.add("fc-hide");
        lightbox.classList.remove("fc-fade-out");
        // Rewrite inner HTML so that videos are paused
        [...lightbox.querySelectorAll("iframe, video")].forEach((video) => {
          video.outerHTML = video.outerHTML;
        });
      }, 200);
      // If there's no open lightboxes, enable scrolling again
      const openLightboxes = document.querySelectorAll(
        ".fc-lightbox-overlay:not(.fc-hide)"
      );
      if (openLightboxes.length === 1) {
        document.documentElement.classList.remove("fc-lightbox-open");
      }
      document.getElementById('full-story-cta').focus();
    };
    // Open the lightbox immediatly if the hash is set
    if (window.location.hash.split("?")[0] === "#" + id) openLightbox();
    // Listen for opening the lightbox
    lightbox.addEventListener("open", openLightbox, false);
    // Events for exiting the lightbox
    lightbox.addEventListener("close", closeLightbox, false);
    container.addEventListener("click", ({ target }) => {
      if (target === container) lightbox.dispatchEvent(new Event("close"));
    });
    // Only do this once
    if (!window.haspopstateLightboxEvent) {
      window.haspopstateLightboxEvent = true;
      // When we press the back button, close any
      window.addEventListener(
        "popstate",
        () => {
          if (window.location.hash === "") {
            const openLightboxElement = document.querySelector(
              ".fc-lightbox-overlay:not(.fc-hide) .fc-lightbox"
            );
            openLightboxElement?.dispatchEvent(new Event("close"));
          }
        },
        false
      );
    }
  }
  function preloadImages(...images) {
    console.log("Preloading images...");
    window.images = window.images || [];
    for (var i = 0; i < images.length; i++) {
      const image = new Image();
      image.src = images[i];
      window.images.push(image);
    }
  }
  async function makeLightbox({ contents, id, style }) {
    const lightbox = document.createElement("div");
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Products Made By Moms In Medicine');
    lightbox.innerHTML = contents;
    lightbox.id = id;
    lightbox.classList.remove("fc-hide");
    lightbox.classList.add("fc-lightbox");
    let container = document.createElement("div");
    container.classList.add(id + "-container");
    container.setAttribute("style", style);
    container.classList.add("fc-hide", "fc-lightbox-overlay");
    const closeButtonSVG = /*static*/ `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M390,308l-7.72,7.72-2.63-2.63,7.72-7.72-8.27-8.27,2.8-2.8,8.27,8.27,7.72-7.72,2.63,2.63-7.72,7.72,8.27,8.27-2.8,2.8Z" transform="translate(-379.1 -294.3)"></path></svg>`;
    const closeButtonHTML = /*static*/ `<button class="fc-lightbox__close" onclick="event.stopPropagation(); this.closest('.fc-lightbox').dispatchEvent(new Event('close'));" aria-label="Close">${closeButtonSVG}</button>`;
    // lightbox.insertAdjacentHTML("afterbegin", "<br />");
    lightbox.insertAdjacentHTML("afterbegin", closeButtonHTML);
    asyncSelect("body").then((body) => body.appendChild(container));
    container.appendChild(lightbox);
    await lightboxEvents(lightbox);
    setTimeout(() => preloadImages(...lightbox.querySelectorAll("img")), 5000);
    trapLightboxFocus();
    return lightbox;
  }
  // Make the lightbox
  makeLightbox({ id, contents: contents });
  if (autoOpen) {
    setTimeout(() => {
      const lightbox = document.getElementById(id);
      lightbox.dispatchEvent(new Event("open"));
    }, parseInt(autoOpen) * 1000 || 0);
  }
},
momsInMedicinSliderEvent: () => {
      var swiper = new Swiper(".fc-lightbox .mim__doctor-carousel", {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 15,
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 3,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      console.log({ swiper });
    },
galleryEvents: async ({ root = "" }) => {
  // See: https://nickpiscitelli.github.io/Glider.js/
  // prettier-ignore
  !function(e){"function"==typeof define&&__webpack_require__.amdO?define(e):"object"==typeof exports?module.exports=e():e()}(function(){var a="undefined"!=typeof window?window:this,e=a.Glider=function(e,t){var o=this;if(e._glider)return e._glider;if(o.ele=e,o.ele.classList.add("glider"),(o.ele._glider=o).opt=Object.assign({},{slidesToScroll:1,slidesToShow:1,resizeLock:!0,duration:.5,easing:function(e,t,o,i,r){return i*(t/=r)*t+o}},t),o.animate_id=o.page=o.slide=0,o.arrows={},o._opt=o.opt,o.opt.skipTrack)o.track=o.ele.children[0];else for(o.track=document.createElement("div"),o.ele.appendChild(o.track);1!==o.ele.children.length;)o.track.appendChild(o.ele.children[0]);o.track.classList.add("glider-track"),o.init(),o.resize=o.init.bind(o,!0),o.event(o.ele,"add",{scroll:o.updateControls.bind(o)}),o.event(a,"add",{resize:o.resize})},t=e.prototype;return t.init=function(e,t){var o,i=this,r=0,s=0,l=(i.slides=i.track.children,[].forEach.call(i.slides,function(e,t){e.classList.add("glider-slide"),e.setAttribute("data-gslide",t)}),i.containerWidth=i.ele.clientWidth,i.settingsBreakpoint());t=t||l,"auto"!==i.opt.slidesToShow&&void 0===i.opt._autoSlide||(o=i.containerWidth/i.opt.itemWidth,i.opt._autoSlide=i.opt.slidesToShow=i.opt.exactWidth?o:Math.max(1,Math.floor(o))),"auto"===i.opt.slidesToScroll&&(i.opt.slidesToScroll=Math.floor(i.opt.slidesToShow)),i.itemWidth=i.opt.exactWidth?i.opt.itemWidth:i.containerWidth/i.opt.slidesToShow,[].forEach.call(i.slides,function(e){e.style.height="auto",e.style.width=i.itemWidth+"px",r+=i.itemWidth,s=Math.max(e.offsetHeight,s)}),i.track.style.width=r+"px",i.trackWidth=r,i.isDrag=!1,i.preventClick=!1,i.move=!1,i.opt.resizeLock&&i.scrollTo(i.slide*i.itemWidth,0),(l||t)&&(i.bindArrows(),i.buildDots(),i.bindDrag()),i.updateControls(),i.emit(e?"refresh":"loaded")},t.bindDrag=function(){function e(){t.mouseDown=void 0,t.ele.classList.remove("drag"),t.isDrag&&(t.preventClick=!0),t.isDrag=!1}var t=this;t.mouse=t.mouse||t.handleMouse.bind(t);function o(){t.move=!0}var i={mouseup:e,mouseleave:e,mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.mouseDown=e.clientX,t.ele.classList.add("drag"),t.move=!1,setTimeout(o,300)},touchstart:function(e){t.ele.classList.add("drag"),t.move=!1,setTimeout(o,300)},mousemove:t.mouse,click:function(e){t.preventClick&&t.move&&(e.preventDefault(),e.stopPropagation()),t.preventClick=!1,t.move=!1}};t.ele.classList.toggle("draggable",!0===t.opt.draggable),t.event(t.ele,"remove",i),t.opt.draggable&&t.event(t.ele,"add",i)},t.buildDots=function(){var e=this;if(e.opt.dots){if("string"==typeof e.opt.dots?e.dots=document.querySelector(e.opt.dots):e.dots=e.opt.dots,e.dots){e.dots.innerHTML="",e.dots.setAttribute("role","tablist"),e.dots.classList.add("glider-dots");for(var t=0;t<Math.ceil(e.slides.length/e.opt.slidesToShow);++t){var o=document.createElement("button");o.dataset.index=t,o.setAttribute("aria-label","Page "+(t+1)),o.setAttribute("role","tab"),o.className="glider-dot "+(t?"":"active"),e.event(o,"add",{click:e.scrollItem.bind(e,t,!0)}),e.dots.appendChild(o)}}}else e.dots&&(e.dots.innerHTML="")},t.bindArrows=function(){var o=this;o.opt.arrows?["prev","next"].forEach(function(e){var t=o.opt.arrows[e];(t=t&&("string"==typeof t?document.querySelector(t):t))&&(t._func=t._func||o.scrollItem.bind(o,e),o.event(t,"remove",{click:t._func}),o.event(t,"add",{click:t._func}),o.arrows[e]=t)}):Object.keys(o.arrows).forEach(function(e){e=o.arrows[e];o.event(e,"remove",{click:e._func})})},t.updateControls=function(e){var n=this,t=(e&&!n.opt.scrollPropagate&&e.stopPropagation(),n.containerWidth>=n.trackWidth),a=(n.opt.rewind||(n.arrows.prev&&(n.arrows.prev.classList.toggle("disabled",n.ele.scrollLeft<=0||t),n.arrows.prev.setAttribute("aria-disabled",n.arrows.prev.classList.contains("disabled"))),n.arrows.next&&(n.arrows.next.classList.toggle("disabled",Math.ceil(n.ele.scrollLeft+n.containerWidth)>=Math.floor(n.trackWidth)||t),n.arrows.next.setAttribute("aria-disabled",n.arrows.next.classList.contains("disabled")))),n.slide=Math.round(n.ele.scrollLeft/n.itemWidth),n.page=Math.round(n.ele.scrollLeft/n.containerWidth),n.slide+Math.floor(Math.floor(n.opt.slidesToShow)/2)),d=Math.floor(n.opt.slidesToShow)%2?0:a+1;1===Math.floor(n.opt.slidesToShow)&&(d=0),n.ele.scrollLeft+n.containerWidth>=Math.floor(n.trackWidth)&&(n.page=n.dots?n.dots.children.length-1:0),[].forEach.call(n.slides,function(e,t){var o=e.classList,e=o.contains("visible"),i=n.ele.scrollLeft,r=n.ele.scrollLeft+n.containerWidth,s=n.itemWidth*t,l=s+n.itemWidth,s=([].forEach.call(o,function(e){/^left|right/.test(e)&&o.remove(e)}),o.toggle("active",n.slide===t),a===t||d&&d===t?o.add("center"):(o.remove("center"),o.add([t<a?"left":"right",Math.abs(t-(!(t<a)&&d||a))].join("-"))),Math.ceil(s)>=Math.floor(i)&&Math.floor(l)<=Math.ceil(r));o.toggle("visible",s),s!==e&&n.emit("slide-"+(s?"visible":"hidden"),{slide:t})}),n.dots&&[].forEach.call(n.dots.children,function(e,t){e.classList.toggle("active",n.page===t)}),e&&n.opt.scrollLock&&(clearTimeout(n.scrollLock),n.scrollLock=setTimeout(function(){clearTimeout(n.scrollLock),.02<Math.abs(n.ele.scrollLeft/n.itemWidth-n.slide)&&(n.mouseDown||n.trackWidth>n.containerWidth+n.ele.scrollLeft&&n.scrollItem(n.getCurrentSlide()))},n.opt.scrollLockDelay||250))},t.getCurrentSlide=function(){return this.round(this.ele.scrollLeft/this.itemWidth)},t.scrollItem=function(e,t,o){o&&o.preventDefault();var i,r=this,s=e,o=(++r.animate_id,r.slide),l=!0===t?(e=Math.round(e*r.containerWidth/r.itemWidth))*r.itemWidth:("string"==typeof e&&(l="prev"===e,e=r.opt.slidesToScroll%1||r.opt.slidesToShow%1?r.getCurrentSlide():r.slide,l?e-=r.opt.slidesToScroll:e+=r.opt.slidesToScroll,r.opt.rewind&&(i=r.ele.scrollLeft,e=l&&!i?r.slides.length:!l&&i+r.containerWidth>=Math.floor(r.trackWidth)?0:e)),e=Math.max(Math.min(e,r.slides.length),0),r.slide=e,r.itemWidth*e);return r.emit("scroll-item",{prevSlide:o,slide:e}),r.scrollTo(l,r.opt.duration*Math.abs(r.ele.scrollLeft-l),function(){r.updateControls(),r.emit("animated",{value:s,type:"string"==typeof s?"arrow":t?"dot":"slide"})}),!1},t.settingsBreakpoint=function(){var e=this,t=e._opt.responsive;if(t){t.sort(function(e,t){return t.breakpoint-e.breakpoint});for(var o=0;o<t.length;++o){var i=t[o];if(a.innerWidth>=i.breakpoint)return e.breakpoint!==i.breakpoint&&(e.opt=Object.assign({},e._opt,i.settings),e.breakpoint=i.breakpoint,!0)}}var r=0!==e.breakpoint;return e.opt=Object.assign({},e._opt),e.breakpoint=0,r},t.scrollTo=function(t,o,i){var r=this,s=(new Date).getTime(),l=r.animate_id,n=function(){var e=(new Date).getTime()-s;r.ele.scrollLeft=r.ele.scrollLeft+(t-r.ele.scrollLeft)*r.opt.easing(0,e,0,1,o),e<o&&l===r.animate_id?a.requestAnimationFrame(n):(r.ele.scrollLeft=t,i&&i.call(r))};a.requestAnimationFrame(n)},t.removeItem=function(e){var t=this;t.slides.length&&(t.track.removeChild(t.slides[e]),t.refresh(!0),t.emit("remove"))},t.addItem=function(e){this.track.appendChild(e),this.refresh(!0),this.emit("add")},t.handleMouse=function(e){var t=this;t.mouseDown&&(t.isDrag=!0,t.ele.scrollLeft+=(t.mouseDown-e.clientX)*(t.opt.dragVelocity||3.3),t.mouseDown=e.clientX)},t.round=function(e){var t=1/(this.opt.slidesToScroll%1||1);return Math.round(e*t)/t},t.refresh=function(e){this.init(!0,e)},t.setOption=function(t,e){var o=this;o.breakpoint&&!e?o._opt.responsive.forEach(function(e){e.breakpoint===o.breakpoint&&(e.settings=Object.assign({},e.settings,t))}):o._opt=Object.assign({},o._opt,t),o.breakpoint=0,o.settingsBreakpoint()},t.destroy=function(){function e(t){t.removeAttribute("style"),[].forEach.call(t.classList,function(e){/^glider/.test(e)&&t.classList.remove(e)})}var t=this,o=t.ele.cloneNode(!0);t.opt.skipTrack||(o.children[0].outerHTML=o.children[0].innerHTML),e(o),[].forEach.call(o.getElementsByTagName("*"),e),t.ele.parentNode.replaceChild(o,t.ele),t.event(a,"remove",{resize:t.resize}),t.emit("destroy")},t.emit=function(e,t){e=new a.CustomEvent("glider-"+e,{bubbles:!this.opt.eventPropagate,detail:t});this.ele.dispatchEvent(e)},t.event=function(e,t,o){var i=e[t+"EventListener"].bind(e);Object.keys(o).forEach(function(e){i(e,o[e])})},e});
  const rootElem = root === "" ? document : document.querySelector(root);
  const gliders = await asyncSelectAll(".glider", rootElem);
  console.log({ gliders }, "galleryEvents");
  gliders.forEach((glider) => {
    glider.id = glider.id || "glider-" + Math.random().toString().slice(-8);
    const gliderEvents = () => {
      [...glider.querySelectorAll("p:empty")].forEach((x) => x.remove());
      const gliderClass = new Glider(glider, {
        slidesToShow: glider.dataset.slidesToShow,
        slidesToScroll: glider.dataset.slidesToShow,
        draggable: false,
        dots: glider.parentElement.querySelector(".glider-dots"),
      });
      const nextButton = glider.parentElement.querySelector(".glider-next");
      const prevButton = glider.parentElement.querySelector(".glider-prev");
      const lastSlide = gliderClass.slides.length;
      const nextSlide = () => (gliderClass.slide + 1) % lastSlide;
      const prevSlide = () => (lastSlide + gliderClass.slide - 1) % lastSlide;
      nextButton.addEventListener("click", () => {
        glider.parentElement.dataset.slideIndex = nextSlide();
        gliderClass.scrollItem(nextSlide());
      });
      prevButton.addEventListener("click", () => {
        glider.parentElement.dataset.slideIndex = prevSlide();
        gliderClass.scrollItem(prevSlide());
      });
    };
    const containingLightbox = glider.closest(".fc-lightbox");
    if (containingLightbox) {
      const containingLightboxIsOpen =
        !containingLightbox.parentElement.classList.contains("fc-hide");
      if (containingLightboxIsOpen) return gliderEvents();
      containingLightbox.addEventListener("open", () => {
        setTimeout(gliderEvents, 1000);
      });
    } else {
      gliderEvents();
    }
  });
  let i = 0;
  setInterval(async () => {
    gliders.forEach((glider) => {
      if (i === 0) return;
      const gliderShouldSlide =
        glider.dataset.autoSlide !== "-1" &&
        i % parseInt(glider.dataset.autoSlide) === 0;
      if (gliderShouldSlide) {
        // Avoid closing cart drawers by scrolling outside when it's open
        const cartDrawer = document.querySelector("#CartDrawer");
        if (
          cartDrawer &&
          cartDrawer.classList.contains("drawer--is-open") &&
          !glider.closest("#CartDrawer")
        ) {
          return;
        }
        // Automatically slide the slider
        glider.parentElement.querySelector(".glider-next").click();
      }
    });
    i++;
  }, 1000);
},
loadCheckpointEvents: async () => {
  let checkpointObserver = new IntersectionObserver(function (checkpoints) {
    checkpoints.forEach(function (checkpoint) {
      if (checkpoint.isIntersecting) {
        let checkpointElem = checkpoint.target;
        checkpointElem.classList.add("triggered");
        console.log("Triggered", checkpointElem.dataset.id);
        window._vis_opt_queue = window._vis_opt_queue || [];
        window._vis_opt_queue.push(() => {
          _vis_opt_goal_conversion(parseInt(checkpointElem.dataset.id));
        });
        checkpointObserver.unobserve(checkpointElem);
      }
    });
  });
  /** Now observe all the non-loaded images using the observer we have setup above **/
  const addObservers = async () => {
    const checkpointElems = await asyncSelectAll(".fc-checkpoint");
    checkpointElems.forEach((elem) => {
      checkpointObserver.observe(elem);
    });
  };
  addObservers();
  setTimeout(addObservers, 4000);
},
trackTestInfo: () => {
  if (typeof hj !== "undefined") hj("event", "fc-test-" + testMetadata.id);
  if (typeof CE2 !== "undefined") CE2.addTag("fc-test-" + testMetadata.id);
  if (window.clarity) window.clarity("set", "fc-test-" + testMetadata.id, true);
},
};
class ChangeQueue {
  constructor() {
    this.testCSS = "";
  }
  async do(changes) {
    const changeFunctions = changes.map((change) =>
      this.getChangeFunction(change)
    );
    for (let i = 0; i < changes.length; i++) {
      const change = changes[i];
      const actionFunction = changeFunctions[i];
      this.doChange({ change, actionFunction });
    }
    this.afterChanges();
  }
  async doChange({ change, actionFunction }) {
    if (!this.shouldDoChange(change)) return;
    if (change.wait) {
      await new Promise((resolve) => {
        setTimeout(resolve, parseInt(change.wait) * 1000);
        // Once we've waited to add the change, enforce choreographed button rules
        setTimeout(choreographedButtonsEvents, 100);
      });
    }
    const response = actionFunction(change);
    // Action function can update change settings
    change = { ...change, ...response };
    if (change.css) this.testCSS += change.css;
    if (change.js) {
      try {
        change.js(change);
      } catch (error) {
        console.error("Error with", change, { error });
      }
    }
  }
  evalLocalStorageBool(varString) {
    if (varString.includes(" and ")) {
      return varString
        ?.split(" and ")
        .map((varName) => localStorage.getItem(varName))
        .every((value) => value === "true");
    }
    return varString
      ?.split(" or ")
      .map((varName) => localStorage.getItem(varName))
      .includes("true");
  }
  // Don't do the change when the "if" or "unless" attributes doesn't pass
  shouldDoChange(change) {
    if (change.if && !this.evalLocalStorageBool(change.if)) return false;
    if (change.unless && this.evalLocalStorageBool(change.unless)) return false;
    if (change.onPath && change.onPath !== window.location.pathname)
      return false;
    return true;
  }
  getChangeFunction(change) {
    function actionFunction() {
      try {
        if (change.inline) {
          // All inline changes don't have p elements
          change.contents = change.contents.replace(/\<\/? *[pP][^>]*\>/g, "");
        }
        if (change.delay) {
          setTimeout(
            () => actionFunctions[change.type](change),
            change.delay * 1000
          );
        } else {
          return actionFunctions[change.type](change);
        }
      } catch (error) {
        console.error("Error with", change, { error });
      }
    }
    return actionFunction;
  }
  // What to run once all test changes have been
  afterChanges() {
    // Add variables
    asyncSelectAll("[data-variable-name]").then((variableElems) => {
      variableElems.forEach((variableElem) => {
        const { variableName } = variableElem.dataset;
        const value = localStorage.getItem(variableName);
        if (value) variableElem.innerHTML = value;
      });
    });
    // Evaluate if statements
    asyncSelectAll("[data-if]").then((ifElems) => {
      ifElems.forEach((ifElem) => {
        if (this.evalLocalStorageBool(ifElem.dataset.if))
          ifElem.classList.remove("fc-hide");
      });
    });
    asyncSelectAll("[data-unless]").then((unlessElems) => {
      unlessElems.forEach((unlessElem) => {
        if (this.evalLocalStorageBool(unlessElem.dataset.if))
          unlessElem.classList.remove("fc-hide");
      });
    });
    // Add Injected CSS
    document.head.insertAdjacentHTML(
      "beforeEnd",
      `<style id="fc-injected-style" type="text/css">${this.testCSS}</style>`
    );
  }
}
function choreographedButtonsEvents() {
  // Hide all other buttons that open the same lightbox
  const fcClickedCTA = JSON.parse(
    localStorage.getItem("fc-clicked-cta-" + testMetadata.id)
  );
  if (!fcClickedCTA) {
    // Show all ctas
    const showAllCTAs = () =>
      asyncSelectAll(`[data-open-lightbox]:not(.fc-show)`).then((buttons) => {
        buttons.forEach((button) => {
          button.classList.add("fc-show");
          button.closest(".cta-container")?.classList.add("fc-show");
        });
      });
    showAllCTAs();
    setTimeout(showAllCTAs, 1000);
    return;
  }
  Object.keys(fcClickedCTA).forEach((lightboxSelector) => {
    asyncSelectAll(`[data-open-lightbox="${lightboxSelector}"]`).then(
      (buttons) => {
        buttons.forEach((button, i) => {
          if (
            i === fcClickedCTA[lightboxSelector].buttonIndex &&
            window.location.pathname === fcClickedCTA[lightboxSelector].path
          ) {
            button.classList.add("fc-show");
            button.closest(".cta-container")?.classList.add("fc-show");
          }
        });
      }
    );
  });
}
const changeQueue = new ChangeQueue(actionFunctions);
changeQueue.do(actions).then(async () => {
  // Post changes events
  choreographedButtonsEvents();
});

function trapLightboxFocus() {
  var dialog = document.querySelector('#full-story[role="dialog"]');
  var firstFocusableElement = dialog.querySelector('.fc-lightbox__close');
  var lastFocusableElement = dialog.querySelector('.fc-btn--close-lightbox');

  dialog.addEventListener('keydown', function(e) {
    if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });
}
